// src/components/KPICard.tsx
import React from 'react';

interface KPICardProps {
  label: string;
  value: string | number;
  subline: string;
  sparklineData?: number[];
  state?: 'normal' | 'critical' | 'ok';
  className?: string;
}

export const KPICard: React.FC<KPICardProps> = ({
  label,
  value,
  subline,
  sparklineData,
  state = 'normal',
  className = '',
}) => {
  const cardClasses = [
    'panel',
    'panel--kpi',
    state === 'critical' && 'panel--kpi--critical',
    state === 'ok' && 'panel--kpi--ok',
    className,
  ].filter(Boolean).join(' ');

  const valueClasses = [
    'kpi__value',
    state === 'critical' && 'kpi__value--critical',
    state === 'ok' && 'kpi__value--ok',
  ].filter(Boolean).join(' ');

  // Simple SVG sparkline
  const renderSparkline = () => {
    if (!sparklineData || sparklineData.length < 2) return null;
    const width = 200;
    const height = 32;
    const min = Math.min(...sparklineData);
    const max = Math.max(...sparklineData);
    const range = max - min || 1;

    const points = sparklineData.map((v, i) => {
      const x = (i / (sparklineData.length - 1)) * width;
      const y = height - ((v - min) / range) * height * 0.8 - height * 0.1;
      return `${x},${y}`;
    }).join(' ');

    return (
      <svg className="kpi__sparkline" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
        <polyline
          points={points}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.4"
        />
        <polygon
          points={`0,${height} ${points} ${width},${height}`}
          fill="var(--accent)"
          opacity="0.1"
        />
      </svg>
    );
  };

  return (
    <div className={cardClasses}>
      <div className="kpi__label">{label}</div>
      <div className={valueClasses}>{value}</div>
      <div className="kpi__subline">{subline}</div>
      {renderSparkline()}
    </div>
  );
};

export default KPICard;
